export default __webpack_public_path__ + "static/media/2_asksuite.f325f21d.svg";